import React, { useState } from 'react';
import { SxStyle } from '../../../../types';
import Box from '@mui/material/Box';
import { BottomBarPreviewItem, EditableBottomBarItem } from '../types';
import AppMenuPreviewItem from './app-menu-preview-item';
import AppMenuPreviewMenu from './app-menu-preview-menu';
import PreviewTopBar from '../../../common/preview-topbar';
import { useConfig } from '../../../../contexts/config';
import PreviewBox from '../../../common/preview-box';
import { darkenColor } from '../../../common/team/categories/theme/theme';

const MAX_ITEMS_PRIMARY = 4;

const styles: SxStyle = {
  content: {
    width: '370px',
    height: '650px',
  },
  container: {
    borderRadius: '16px',
    height: '100%',
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
  },
  bottomContent: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  bottomBarContainer: {
    height: '64px',
    width: '100%',
    borderTop: '1px solid',
    display: 'flex',
    justifyContent: 'space-between',
    paddingX: 2,
    borderBottomLeftRadius: '16px',
    borderBottomRightRadius: '16px',
  },
};

const homeItem: BottomBarPreviewItem = {
  id: 1,
  type: 'start',
  text: 'Hem',
  icon: 'Home',
};

const menuItemExpanded: BottomBarPreviewItem = {
  id: 2,
  type: 'menu',
  text: 'Mer',
  icon: 'More',
};

const menuItemClosed: BottomBarPreviewItem = {
  id: 3,
  type: 'menu',
  text: 'Stäng',
  icon: 'Close',
};

interface Props {
  bottomBarItems?: EditableBottomBarItem[];
}

const AppMenuPreview = ({ bottomBarItems }: Props) => {
  const { appConfig, teamConfig } = useConfig();

  const [menuExpanded, setMenuExpanded] = useState(false);

  const palette = appConfig?.appThemeV2?.palette;
  const topBarOverride = appConfig?.appThemeV2?.topBarOverride;

  const combinedStyleContainer = {
    ...styles.container,
    ...{ backgroundColor: darkenColor(palette?.ID_MAIN || 'black', 0.2) },
  };
  const combinedStyleBottomBar = {
    ...styles.bottomBarContainer,
    ...{ borderTopColor: palette?.ID_CONTRAST },
    ...{ backgroundColor: palette?.ID_MAIN || 'black' },
  };

  const bottomBarItemsPrimary = bottomBarItems?.slice(0, MAX_ITEMS_PRIMARY) || [];
  const bottomBarItemsSecondary = bottomBarItems?.slice(MAX_ITEMS_PRIMARY) || [];

  if (!palette) {
    return null;
  }

  return (
    <Box sx={styles.content}>
      <PreviewBox>
        <Box sx={combinedStyleContainer}>
          <PreviewTopBar
            logoImageUrl={teamConfig?.logoImageUrl}
            backgroundColor={topBarOverride ? palette.TOP_BAR_BACKGROUND : palette.ID_MAIN}
            foregroundColor={topBarOverride ? palette.TOP_BAR_FOREGROUND : palette.ID_FOREGROUND}
            borderColor={palette?.ID_CONTRAST}
          />
          <Box sx={styles.bottomContent}>
            {menuExpanded && (
              <AppMenuPreviewMenu
                palette={palette}
                bottomBarItemsSecondary={bottomBarItemsSecondary.reverse()}
              />
            )}
            <Box sx={combinedStyleBottomBar}>
              <AppMenuPreviewItem bottomBarItem={homeItem} />
              {bottomBarItemsPrimary?.map((item) => (
                <AppMenuPreviewItem key={item.id} bottomBarItem={item} />
              ))}
              {bottomBarItemsSecondary?.length ? (
                <AppMenuPreviewItem
                  bottomBarItem={menuExpanded ? menuItemClosed : menuItemExpanded}
                  onClick={() => setMenuExpanded(!menuExpanded)}
                />
              ) : null}
            </Box>
          </Box>
        </Box>
      </PreviewBox>
    </Box>
  );
};

export default AppMenuPreview;
